import { Pagination } from '@mui/material';
import { useIntl } from 'react-intl';
import { default as TaskTable } from './TaskTable';
import { useEffect, useRef, useState } from 'react';
import {
  listLeadControlTasks,
  LEAD_CONTROL_TASKS_PER_PAGE,
} from '../services/LeadControlCRUD';
import { TaskModel } from '../models/TaskModel';

enum LeadControlTaskListState {
  LOADING = 'loading',
  IDLE = 'idle',
}
export default function LeadControlTaskList() {
  const intl = useIntl();
  const [tasks, setTasks] = useState<TaskModel[]>([]);
  const [state, setState] = useState<LeadControlTaskListState>(
    LeadControlTaskListState.LOADING
  );
  const [currentAttemptNumber, setCurrentAttemptNumber] = useState<
    number | null
  >(null);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const initializedRef = useRef(false);

  async function fetchTasks(targetPage = page) {
    try {
      setState(LeadControlTaskListState.LOADING);
      const offset = (targetPage - 1) * LEAD_CONTROL_TASKS_PER_PAGE;

      const { data } = await listLeadControlTasks({
        currentAttemptNumber,
        limit: LEAD_CONTROL_TASKS_PER_PAGE,
        offset,
      });
      setTasks(data.results);
      setTotalCount(data.count);
      setPage(targetPage);
      setState(LeadControlTaskListState.IDLE);
    } catch (error) {
      console.error('Error fetching tasks:', error);
      setState(LeadControlTaskListState.IDLE);
    }
  }

  useEffect(() => {
    if (!initializedRef.current) {
      initializedRef.current = true;
      setState(LeadControlTaskListState.IDLE);
      return;
    }
    setPage(1);
    fetchTasks(1);
  }, [currentAttemptNumber]);

  return (
    <>
      <main className="card p-10">
        <div className="d-flex justify-content-between mb-4 align-items-center">
          <h1 className="text-2xl font-bold">
            {intl.formatMessage({ id: 'tasks.leadControlTasks' })}
          </h1>
        </div>
        <TaskTable
          tasks={tasks}
          displayClient={true}
          onRefresh={() => fetchTasks(page)}
          loading={state === LeadControlTaskListState.LOADING}
          bulkReassignDisabled={true}
          isDisplayingLeadControlTasks={true}
        >
          <div className="form-group">
            <label htmlFor="attemptNumber" className="form-label">
              {intl.formatMessage({ id: 'tasks.filterByAttemptNumber' })}
            </label>
            <input
              min={1}
              max={9}
              step={1}
              type="number"
              className="form-control"
              id="attemptNumber"
              value={currentAttemptNumber || ''}
              onChange={(e) => {
                const value = e.target.value;
                setCurrentAttemptNumber(value ? parseInt(value) : null);
              }}
              placeholder={intl.formatMessage({
                id: 'tasks.attemptNumberPlaceholder',
              })}
            />
          </div>
        </TaskTable>
        {totalCount > 0 && (
          <Pagination
            className="mx-auto mt-4 d-flex justify-content-center"
            count={Math.ceil(totalCount / LEAD_CONTROL_TASKS_PER_PAGE)}
            page={page}
            onChange={(_e, newPage) => fetchTasks(newPage)}
          />
        )}
      </main>
    </>
  );
}
